import { useMemo } from "react"

export const useAssetsCards = () => {


    const getIcon = (name) => {
        if (name?.toLowerCase() === "total assets") {
            return { icon: "fa-solid fa-layer-group", color: "#0d6efd", backgroundColor: "#e7f3ff" };
        } else if (name?.toLowerCase() === "laptop") {
            return { icon: "fa-solid fa-laptop", color: "#00a400", backgroundColor: "#d4f1d4" };
        } else if (name?.toLowerCase() === "desktop") {
            return { icon: "fa-solid fa-desktop", color: "#6b7280", backgroundColor: "#f3f4f6" };
        } else if (name?.toLowerCase() === "server") {
            return { icon: "fa-solid fa-server", color: "#0d6efd", backgroundColor: "#e7f3ff" };
        } else if (name?.toLowerCase() === "storage") {
            return { icon: "fa-solid fa-hard-drive", color: "#00a400", backgroundColor: "#d4f1d4" };
        } else {
            return { icon: "fa-solid fa-microchip", color: "#6b7280", backgroundColor: "#f3f4f6" };
        }
    };


    return useMemo(() => ({
        getIcon
    }), [getIcon])
}